import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        // Minimal placeholder — avoid a full layout flash before we know auth state.
        return (
            <div
                className="min-h-screen flex items-center justify-center bg-background"
                data-testid="auth-loading"
            >
                <div className="text-xs text-muted-foreground tracking-[0.25em] uppercase">
                    Verifying session…
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
